import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { InputSelect } from '../../models/pages-model/form-general.model';

@Component({
  standalone: true,
  selector: 'app-input-general-select',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule,
  ],
  templateUrl: './input-general-select.component.html',
})
export class InputGeneralSelectComponent {
  @Input() formControlGeneral: FormControl | AbstractControl | null = new FormControl();
  @Input() placeholder = '';
  @Input() label = '';
  @Input() multiple = false;
  @Input() inputSelect: InputSelect = { value: '', description: '' };
  @Input() arrayData: any = [];

  public getNestedProperty(obj: any, path: string): any {
    const pathArray = path.split('.');
    return pathArray.reduce((acc, current) => (acc ? acc[current] : null), obj);
  }

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }

  get getInputGeneral(): FormControl {
    return this.formControlGeneral as FormControl;
  }
}
